<template>
    <div class="d-flex align-items-center gap-3 mb-5">
        <router-link :to="backTo" class="back-button">
            <span class="icon svg-icon svg-icon-2 svg-icon-primary">
                <inline-svg src="/media/icons/duotune/arrows/arr002.svg"/>
            </span>
            <span class="text">{{ $t('common.back') }}</span>
        </router-link>
        <el-divider direction="vertical"/>
        <h2 class="fs-2 fw-bold my-2">{{ title }}</h2>
    </div>
</template>

<script>

export default {
    name: "page-header",
    components: {},
    props: {
        title: {type: String},
        backTo: {type: String},
    },
}
</script>

<style>
</style>